<!--
 * @Description: 项目的主入口
 * @Author: gao shuai
 * @Date: 2020-02-15 13:42:21
 * @LastEditTime: 2020-08-27 16:11:54
 * @LastEditors: gao shuai
 -->

<template>
  <div class="home">
    <div class="header">
      <div class="logoimg">
        <img src="../assets/images/logo.png" alt="" />
      </div>
      <div class="navbox">
        <el-tabs type="card">
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon01" @click="reload2('/home/chart')"
                >首页</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span
                class="navlist icon02"
                @click="reload2('/home/merchantplat')"
                >商户列表</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon03" @click="reload2('/home/orderplat')"
                >订单列表</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon04" @click="reload2('/home/moneylist')"
                >资金管理</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon05" @click="reload2('/home/gamearea')"
                >分区管理</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon06" @click="reload2('/home/gamegroup')"
                >分组管理</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span
                class="navlist icon07"
                @click="reload2('/home/apaythoroughfare')"
                >通道管理</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon08" @click="reload2('/home/apayproudce')"
                >产品管理</span
              >
            </span>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              <span class="navlist icon09" @click="reload2('/home/systemset')"
                >系统配置</span
              >
            </span>
          </el-tab-pane>
          <!-- <el-tab-pane>
            <span slot="label">
              <span class="navlist icon09" @click="reload2('/home/systemset')"
                >代付管理</span
              >
            </span>
          </el-tab-pane> -->
        </el-tabs>
      </div>
      <div class="settingBox">
        <!-- <span class="message"><i>5</i></span> -->
        <span class="setting mgl35">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="sconedPassword"
                >更改二级密码</el-dropdown-item
              >
              <el-dropdown-item command="loginout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </div>
    </div>
    <div class="container">
      <div class="slider" :class="{ on: sliderflag }">
        <span class="silderbtn" @click="silderbtn"></span>
        <div class="scrollbox">
          <div class="adminBox clearfix">
            <!-- <div class="imgbox fl">
              <img src="../assets/images/profit.png" alt="">
            </div> -->
            <el-upload
              class="imgbox fl"
              accept=".jpg,.jpeg,.png"
              action=""
              :http-request="() => {}"
              :before-upload="fileSelect"
              :show-file-list="false"
            >
              <img v-if="headimg" :src="headimg" class="avatar" />
              <img v-else src="../assets/images/profit.png" class="avatar" />
            </el-upload>
            <div class="info fl">
              <p class="name">Admin</p>
              <p class="name">系统管理员</p>
            </div>
          </div>
          <div class="sliderList">
            <dl v-for="(item, i) in sliderlist" :key="'first' + i">
              <dt
                @click="toggleShow(i, item.path)"
                :class="{ active: item.show }"
              >
                <span :class="item.icon">{{ item.title }}</span>
              </dt>
              <dd>
                <el-collapse-transition>
                  <ul v-if="item.show">
                    <li
                      v-for="(li, k) in item.list"
                      :key="'second' + k"
                      :class="{ on: li.active }"
                      @click="itemclick(i, k, li.path)"
                    >
                      {{ li.tit }}
                    </li>
                  </ul>
                </el-collapse-transition>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="pageContainer" :class="{ on: sliderflag }" v-if="showView">
        <router-view></router-view>
      </div>
    </div>
    <!-- <div class="footerbox clearfix">
      <div class="text">支付程序：<span>多渠道兑换平台</span></div>
      <div class="time">系统到期时间：<span>{{limitTime}}</span></div>
    </div> -->
    <!-- 修改二级密码弹框 -->
    <el-dialog
      title="修改二级密码"
      :visible.sync="dialog.show"
      @close="dialoginit"
      custom-class="gs_dialog"
      width="470px"
    >
      <div class="dialoglist">
        <ul>
          <li class="clearfix">
            <span class="tit">旧二级密码</span>
            <span class="txtbox">
              <el-input
                size="small"
                type="password"
                v-model="dialog.oldPassword"
              ></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class="tit">新二级密码</span>
            <span class="txtbox">
              <el-input
                size="small"
                type="password"
                v-model="dialog.newPassword"
              ></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class="tit">确认二级密码</span>
            <span class="txtbox">
              <el-input
                size="small"
                type="password"
                v-model="dialog.surePassword"
              ></el-input>
            </span>
          </li>
        </ul>
      </div>
      <div class="button_center">
        <el-button size="small" type="primary" @click="passwordSubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Mgr from '../assets/js/SecurityService';
export default {
  name: 'Home',
  data() {
    return {
      sliderflag: false,
      showView: true, // 刷新Flag
      headimg: '', // 图像
      dialog: {
        show: false, // 弹框的显隐
        oldPassword: '', // 旧密码
        newPassword: '', // 新密码
        surePassword: '' // 确认密码
      },
      sliderlist: [
        {
          title: '公告管理',
          show: false,
          icon: 'icon1',
          path: 'newsMessagelist',
          list: []
          // list: [
          //   {
          //     tit: '消息列表',
          //     active: false,
          //     path: 'newsMessagelist'
          //   }
          // ]
        },
        {
          title: '商户管理',
          show: false,
          icon: 'icon2',
          list: [
            {
              tit: '平台商户',
              active: false,
              path: 'merchantplat'
            },
            {
              tit: '代理商户',
              active: false,
              path: 'merchantagent'
            },
            {
              tit: '注册商户',
              active: false,
              path: 'merchantregister'
            }
          ]
        },
        {
          title: '商户进件',
          show: false,
          icon: 'icon2',
          list: [
            {
              tit: '统统付',
              active: false,
              path: 'profitsharingsumpay'
            }
          ]
        },
        {
          title: '订单管理',
          show: false,
          icon: 'icon3',
          list: [
            {
              tit: '平台订单',
              active: false,
              path: 'orderplat'
            },
            {
              tit: '代理订单',
              active: false,
              path: 'orderagent'
            },
            {
              tit: '平台返单',
              active: false,
              path: 'backOrder'
            },
            {
              tit: '补发记录',
              active: false,
              path: 'orderreissue'
            }
          ]
        },
        {
          title: '数据导出',
          show: false,
          icon: 'icon8',
          path: 'exportTxt',
          list: [
            // {
            //   tit: '系统日志',
            //   active: false,
            //   path: 'Logdailyrecord'
            // }
          ]
        },
        {
          title: '游戏管理',
          show: false,
          icon: 'icon4',
          list: [
            {
              tit: '分组列表',
              active: false,
              path: 'gamegroup'
            },
            {
              tit: '分区列表',
              active: false,
              path: 'gamearea'
            }
          ]
        },
        {
          title: '资金管理',
          show: false,
          icon: 'icon5',
          list: [
            {
              tit: '资金列表',
              active: false,
              path: 'moneylist'
            },
            {
              tit: 'T+1 结算',
              active: false,
              path: 'moneymangeTOne'
            },
            {
              tit: 'T+0 结算',
              active: false,
              path: 'moneymangeTZero'
            },
            {
              tit: '等待审核',
              active: false,
              path: 'moneymangereview'
            },
            {
              tit: '等待付款',
              active: false,
              path: 'moneymangepayment'
            },
            {
              tit: '批复记录',
              active: false,
              path: 'moneymangeexamine'
            },
            {
              tit: '结算记录',
              active: false,
              path: 'moneymangebalance'
            }
          ]
        },
        {
          title: '支付网关',
          show: false,
          icon: 'icon6',
          list: [
            {
              tit: '产品管理',
              active: false,
              path: 'apayproudce'
            },
            {
              tit: '通道管理',
              active: false,
              path: 'apaythoroughfare'
            }
          ]
        },
        {
          title: '系统设置',
          show: false,
          icon: 'icon7',
          list: [
            {
              tit: '费率设置',
              active: false,
              path: 'Systemsetuprate'
            },
            // {
            //   tit: '用户设置',
            //   active: false,
            //   path: 'SystemsetupUserSettings'
            // },
            // {
            //   tit: '角色设置',
            //   active: false,
            //   path: 'SystemsetupRolesetting'
            // },
            // {
            //   tit: '代付配置',
            //   active: false,
            //   path: 'Systemsetuprepay'
            // },
            {
              tit: '域名配置',
              active: false,
              path: 'Systemsetuprealm'
            },
            {
              tit: '资源上传',
              active: false,
              path: 'uploadres'
            },
            {
              tit: '系统配置',
              active: false,
              path: 'systemset'
            },
            {
              tit: '平台公众号配置',
              active: false,
              path: 'syswechatconfig'
            }
          ]
        },
        {
          title: '日志管理',
          show: false,
          icon: 'icon8',
          path: 'Logdailyrecord',
          list: [
            // {
            //   tit: '系统日志',
            //   active: false,
            //   path: 'Logdailyrecord'
            // }
          ]
        },
        {
          title: '代付模块',
          show: false,
          icon: 'icon2',
          list: [
            {
              tit: '版本管理',
              active: false,
              path: 'behalfVersion'
            },
            {
              tit: '概览',
              active: false,
              path: 'echarts'
            },
            {
              tit: '余额明细',
              active: false,
              path: 'behalfBalance'
            },
            {
              tit: '自有账户',
              active: false,
              path: 'selfAccount'
            },
            {
              tit: '待审核订单',
              active: false,
              path: 'daifuRecharge'
            },
            {
              tit: '已完成订单',
              active: false,
              path: 'finishRecharge'
            },
            {
              tit: '黑名单列表',
              active: false,
              path: 'blackList'
            },
            {
              tit: '统计日报',
              active: false,
              path: 'staRecharge'
            },
            {
              tit: '支付宝统计',
              active: false,
              path: 'aliRecharge'
            }
          ]
        },
        {
          title: '数据统计',
          show: false,
          icon: 'icon9',
          list: [
            {
              tit: '商户日交易统计',
              active: false,
              path: 'statisticstenantDayTrade'
            },
            {
              tit: '代理日交易统计',
              active: false,
              path: 'statisticsagentDayTrade'
            },
            {
              tit: '分区充值统计',
              active: false,
              path: 'statisticspartitionTrade'
            },
            {
              tit: '发布站统计',
              active: false,
              path: 'statisticspublish'
            }
          ]
        }
      ]
    };
  },
  methods: {
    // 获取用户图像
    getUserProfit() {
      this.$api.chart
        .getProfile()
        .then(data => {
          this.headimg = data.data;
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 图片上传之前的勾子
    fileSelect(file) {
      let form = new FormData();
      form.append('file', file);
      this.$api.chart
        .uploadprofit(form)
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.getUserProfit();
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    silderbtn() {
      this.sliderflag = !this.sliderflag;
    },
    toggleShow(index, path) {
      this.sliderlist.forEach((item, i) => {
        if (i !== index) {
          item.show = false;
        } else {
          item.show = !item.show;
        }
      });
      if (path) {
        this.sliderlist.forEach((item, i) => {
          item.list.forEach(li => {
            li.active = false;
          });
        });
        if (this.$route.path.indexOf(path) > -1) {
          this.reload1();
        } else {
          this.$router.push({ path: path });
        }
      } else {
        this.sliderlist.forEach((item, i) => {
          item.list.forEach(li => {
            li.active = false;
          });
        });
        this.sliderlist[index].list[0].active = true;
        this.$router.push({ path: this.sliderlist[index].list[0].path });
      }
    },
    itemclick(index1, index2, path) {
      this.sliderlist.forEach((item, i) => {
        if (i !== index1) {
          item.list.forEach(li => {
            li.active = false;
          });
        } else {
          item.list.forEach((li, k) => {
            if (k !== index2) {
              li.active = false;
            } else {
              li.active = true;
            }
          });
        }
      });
      if ('/home/' + path === this.$route.path) {
        this.reload1();
      } else {
        this.$router.push({ path: path });
      }
    },
    // 刷新
    reload1() {
      this.showView = false;
      this.$nextTick(() => {
        this.showView = true;
      });
    },
    reload2(path) {
      if (this.$route.path.indexOf(path) > -1) {
        this.reload1();
      } else {
        this.$router.push({ path: path });
      }
    },
    // 设置中的按钮
    handleCommand(command) {
      if (command === 'loginout') {
        this.$api.chart
          .loginOut()
          .then(data => {
            if (data.status === 200) {
              let user = new Mgr();
              user.signOut();
            }
          })
          .catch(err => {
            this.$messageError(err.message);
          });
      } else if (command === 'sconedPassword') {
        this.dialog.show = true;
      }
    },
    // 二级密码的初始化
    dialoginit() {
      this.dialog.oldPassword = ''; // 旧密码
      this.dialog.newPassword = ''; // 新密码
      this.dialog.surePassword = ''; // 确认密码
    },
    // 修改密码的提交
    passwordSubmit() {
      if (this.dialog.oldPassword === '') {
        this.$messageError('请输入旧二级密码！');
        return;
      } else if (this.dialog.newPassword === '') {
        this.$messageError('请输入新二级密码！');
        return;
      } else if (this.dialog.newPassword !== this.dialog.surePassword) {
        this.$messageError('两次新二级密码输入不一致，请重新输入');
        this.dialog.surePassword = '';
        return;
      }
      this.$api.chart
        .sconedPassword({
          oldPassword: this.dialog.oldPassword,
          password: this.dialog.newPassword,
          confirmPassword: this.dialog.surePassword
        })
        .then(data => {
          if (data.status === 200) {
            this.dialog.show = false;
            this.$messageSuccess('更改二级密码成功！');
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.getUserProfit();
  }
};
</script>
<style>
.el-card__header {
  padding: 10px 20px;
  border: 1px solid #ddd;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #efefef;
  font-size: 14px;
}

.el-card__body {
  border: 1px solid #ddd;
  border-top: none;
}
</style>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  padding-top: 69px;
  // padding-bottom: 40px;
  position: relative;
  box-sizing: border-box;
  .header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 68px;
    border-bottom: 1px solid #bababa;
    display: flex;
    .navbox {
      flex: 1;
      overflow-y: hidden;
      overflow-x: auto;
      &::v-deep .el-tabs__header {
        margin: 0;
        border: none;
        .el-tabs__item {
          border: none;
          height: 68px;
          line-height: 68px;
          padding: 0;
          &.is-active {
            background: #0260ad;
            .navlist {
              color: #fff;
              &.icon01 {
                background: url(../assets/images/nav_01_on.png) no-repeat 15px
                  center;
              }
              &.icon02 {
                background: url(../assets/images/nav_02_on.png) no-repeat 15px
                  center;
              }
              &.icon03 {
                background: url(../assets/images/nav_03_on.png) no-repeat 15px
                  center;
              }
              &.icon04 {
                background: url(../assets/images/nav_04_on.png) no-repeat 15px
                  center;
              }
              &.icon05 {
                background: url(../assets/images/nav_05_on.png) no-repeat 15px
                  center;
              }
              &.icon06 {
                background: url(../assets/images/nav_06_on.png) no-repeat 15px
                  center;
              }
              &.icon07 {
                background: url(../assets/images/nav_07_on.png) no-repeat 15px
                  center;
              }
              &.icon08 {
                background: url(../assets/images/nav_08_on.png) no-repeat 15px
                  center;
              }
              &.icon09 {
                background: url(../assets/images/nav_09_on.png) no-repeat 15px
                  center;
              }
            }
          }
        }
        .el-tabs__nav {
          border: none;
        }
        .el-tabs__nav-wrap {
          .el-tabs__nav-next {
            line-height: 68px;
          }
          .el-tabs__nav-prev {
            line-height: 68px;
          }
        }
      }
      .navlist {
        display: inline-block;
        height: 68px;
        padding-left: 50px;
        padding-right: 20px;
        font-size: 16px;
        color: #272636;
        &.icon01 {
          background: url(../assets/images/nav_01.png) no-repeat 15px center;
        }
        &.icon02 {
          background: url(../assets/images/nav_02.png) no-repeat 15px center;
        }
        &.icon03 {
          background: url(../assets/images/nav_03.png) no-repeat 15px center;
        }
        &.icon04 {
          background: url(../assets/images/nav_04.png) no-repeat 15px center;
        }
        &.icon05 {
          background: url(../assets/images/nav_05.png) no-repeat 15px center;
        }
        &.icon06 {
          background: url(../assets/images/nav_06.png) no-repeat 15px center;
        }
        &.icon07 {
          background: url(../assets/images/nav_07.png) no-repeat 15px center;
        }
        &.icon08 {
          background: url(../assets/images/nav_08.png) no-repeat 15px center;
        }
        &.icon09 {
          background: url(../assets/images/nav_09.png) no-repeat 15px center;
        }
      }
    }
    .logoimg {
      width: 210px;
      // text-align: center;
      padding-right: 30px;
      margin-top: 10px;
    }
    .settingBox {
      width: 190px;
      height: 68px;
      text-align: right;
      .message {
        display: inline-block;
        vertical-align: middle;
        position: relative;
        cursor: pointer;
        height: 32px;
        width: 30px;
        margin-top: 18px;
        background: url(../assets/images/message.png) no-repeat center center;
        i {
          position: absolute;
          border: 1px solid #fff;
          padding: 0 4px;
          height: 18px;
          border-radius: 9px;
          color: #fff;
          text-align: center;
          background: #fc4a3a;
          right: -4px;
          top: 2px;
        }
      }
      .setting {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        margin-top: 18px;
        height: 32px;
        width: 30px;
        margin-right: 15px;
        background: url(../assets/images/setting.png) no-repeat center center;
        .el-dropdown-link {
          display: block;
          width: 32px;
          height: 32px;
        }
      }
    }
  }
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    .slider {
      position: absolute;
      background: #36404c;
      width: 195px;
      height: 100%;
      top: 0;
      left: 0;
      transition: left 1s;
      &.on {
        left: -195px;
      }
      .silderbtn {
        position: absolute;
        top: 0;
        right: -14px;
        height: 45px;
        background: url(../assets/images/slider_arrow.png) no-repeat center
          center;
        cursor: pointer;
        width: 14px;
      }
      .scrollbox {
        height: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
          height: 16px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 4px;
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          background-color: #15596f;
        }
        &::-webkit-scrollbar-track {
          background: #082b38;
        }
        .adminBox {
          height: 65px;
          padding-top: 12px;
          padding-left: 20px;
          background: #2b3541;
          border-bottom: 1px solid #3b4551;
          .imgbox {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background: #fff;
            cursor: pointer;
            img {
              display: block;
              width: 56px;
              height: 56px;
              border-radius: 50%;
            }
          }
          .info {
            font-size: 14px;
            color: #fff;
            margin-left: 14px;
            // margin-top: 12px;
            .name {
              margin-top: 6px;
            }
          }
        }
        .sliderList {
          dl {
            border-bottom: 1px solid #3b4551;
            background: #2b3541;
            dt {
              position: relative;
              height: 54px;
              line-height: 54px;
              color: #fff;
              font-size: 14px;
              cursor: pointer;
              &.active:before {
                content: '';
                position: absolute;
                width: 13px;
                height: 8px;
                background: url(../assets/images/item_on.png) no-repeat center
                  center;
                bottom: -6px;
                left: 85px;
              }
              span {
                display: block;
                padding-left: 72px;
                height: 54px;
                line-height: 54px;
                &.icon1 {
                  background: url(../assets/images/slider_01.png) no-repeat 35px
                    center;
                }
                &.icon2 {
                  background: url(../assets/images/slider_02.png) no-repeat 35px
                    center;
                }
                &.icon3 {
                  background: url(../assets/images/slider_03.png) no-repeat 35px
                    center;
                }
                &.icon4 {
                  background: url(../assets/images/slider_04.png) no-repeat 35px
                    center;
                }
                &.icon5 {
                  background: url(../assets/images/slider_05.png) no-repeat 35px
                    center;
                }
                &.icon6 {
                  background: url(../assets/images/slider_06.png) no-repeat 35px
                    center;
                }
                &.icon7 {
                  background: url(../assets/images/slider_07.png) no-repeat 35px
                    center;
                }
                &.icon8 {
                  background: url(../assets/images/slider_08.png) no-repeat 35px
                    center;
                }
                &.icon9 {
                  background: url(../assets/images/slider_09.png) no-repeat 35px
                    center;
                }
              }
            }
            dd {
              color: #fefefe;
              font-size: 14px;
              background: #36404c;
              li {
                cursor: pointer;
                height: 54px;
                line-height: 54px;
                padding-left: 74px;
                background: url(../assets/images/dot.png) no-repeat 48px center;
                &.on {
                  background: #fff url(../assets/images/slider_on.png) no-repeat
                    48px center;
                  color: #d86359;
                }
              }
            }
          }
        }
      }
    }
    .pageContainer {
      margin-left: 195px;
      transition: margin-left 1s;
      height: 100%;
      &.on {
        margin-left: 0;
      }
    }
  }
  .button_center {
    text-align: center;
    padding-bottom: 10px;
  }
  .dialoglist {
    ul {
      padding-left: 30px;
      li {
        margin-bottom: 10px;
        .tit {
          float: left;
          width: 100px;
          height: 30px;
          line-height: 30px;
        }
        .txtbox {
          float: left;
          width: 250px;
        }
      }
    }
  }
  .footerbox {
    position: absolute;
    width: 100%;
    height: 40px;
    bottom: 0;
    left: 0;
    background: #fff;
    border-top: 1px solid #bababa;
    .text {
      float: left;
      height: 40px;
      line-height: 40px;
      padding-left: 30px;
      color: #555;
      span {
        color: #0260ad;
      }
    }
    .time {
      float: right;
      height: 40px;
      line-height: 40px;
      padding-right: 30px;
      color: #555;
      span {
        color: red;
      }
    }
  }
}
</style>
